import {
  TEACHER_CATHEDRAS_STARTED,
  TEACHER_CATHEDRAS_COMPLETED,
  CURRICULUM_COURSES_STARTED,
  CURRICULUM_COURSES_COMPLETED,
} from '../actions/types';

const initialState = {
  cathedrasList: [],
  coursesList: [],
};

export default function curriculumData(state = initialState, action) {
  switch (action.type) {
    case TEACHER_CATHEDRAS_STARTED:
      return {
        ...state,
      };
    case TEACHER_CATHEDRAS_COMPLETED:
      return {
        ...state,
        cathedrasList: action.data,
      };
    case CURRICULUM_COURSES_STARTED:
      return {
        ...state,
      }
    case CURRICULUM_COURSES_COMPLETED:
      return {
        ...state,
        coursesList: action.data,
      }
    default:
      return state;
  }
}
